<div class="checkbox-section">
    <mat-checkbox class="checkbox {{cssClass}}"
                  [checked]="checked"
                  [disabled]="disabled"
                  [disableRipple]="disableRipple"
                  [labelPosition]="labelPosition"
                  [aria-label]="ariaLabel"
                  (change)="changeCheckedState()">
        <span>{{label}}</span>
    </mat-checkbox>
</div>